var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dispositivo.has_subscription_active)?_c('div',[(_vm.dispositivo.licence.trial)?_c('mensagem-somente-vip-teste'):_vm._e(),_c('Chat',{attrs:{"messenger":"snapchat"}})],1):_c('div',[_c('mensagem-somente-vip')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }